import { axiosGet, axiosPost } from "../../react_axios/Axios";
import moment from "moment";
import {
  DELETE_MY_ORDER_ACTION_TYPE,
  EDIT_ORDER_ACTION_TYPE,
  MY_ORDERS_LIST_ACTION_TYPE,
  INSERT_PROFORMA_INVOICE_ACTION_TYPE,
  deleteMyOrderUrl,
  editOrderUrl,
  myOrdersListUrl,
  insertProformaInvoiceUrl,
  headers,
  blockedTillUrl,
  BLOCKED_TILL_ACTION_TYPE,
  followUpurl,
  FOLLOW_UP_ACTION_TYPE,
  getFollowUpUrl,
  GET_FOLLOWUP_ACTION_TYPE,
  cancelOrderReasonUrl,
  ORDER_CANCEL_REASON_ACTION_TYPE,
  fetchReport,
  DOWNLOAD_PERFORMA_INVOICE,
  performaInvoice,
  noDueCertificate,
  DOWNLOAD_NODUE_ACTION_TYPE,
  generateNoDueUrl,
  GENERATE_NODUE_ACTION_TYPE,
  eventClosureUrl,
  EVENT_CLOSURE_ACTION_TYPE,
  orderApproveUrl,
  ORDER_APPROVAL_ACTION_TYPE,
  paymentUrl,
  PAYMENT_ACTION_TYPE,
  generateUniqueNoUrl,
  GENERATE_UNIQUE_NO,
  orderAdditionalServicesIEUrl,
  ORDER_ADDITIONAL_SERVICE_IE_TYPE,
  updateExitPassUrl,
  UPDATE_EXIT_PASS_ACTION_TYPE,
  orderAdditionalServicesApprovalUrl,
  ORDER_ADDITIONAL_SERVICE_APPROVAL_ACTION_TYPE,
  orderUpdateAdditionalHourUrl,
  ORDER_UPDATE_ADDITIONAL_HOUR,
  exitPassCertificate,
  orderUpdateAdditionalDiscountUrl,
  ORDER_UPDATE_ADDITIONAL_DISCOUNT,
  orderUpdateRentalDiscountUrl,
  ORDER_UPDATE_RENTAL_DISCOUNT,
  DOWNLOAD_TAX_INVOICE,
  taxInvoice,
  orderUpdateSecurityDepositUrl,
  ORDER_UPDATE_SECURITY_DEPOSIT,
  orderUpdateEventServiceUrl,
  ORDER_UPDATE_EVENT_SERVICE,
  sendApprovalPiMailUrl,
  SEND_APPROVAL_PI_MAIL,
  performaInvoiceExit,
  bookingFormRPT,
  DOWNLOAD_BOOKING_FORM,
} from "../../utils/constants";

export const myOrders_list_action =
  (OrderID, FromDate, ToDate, StatusID, CompanyName) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") != ""
            ? sessionStorage.getItem("userId")
            : null,
        OrderID: OrderID !== null && OrderID != "" ? OrderID : null,
        FromDate: FromDate != null && FromDate != "null" ? FromDate : null,
        ToDate: ToDate != null && ToDate != "null" ? ToDate : null,
        StatusID: StatusID != null && StatusID != "" ? StatusID : null,
        CompanyName:
          CompanyName != null && CompanyName != "" ? CompanyName : null,
      };

      console.log("MyOrders mapdata...", mapdata);
      const res = await axiosGet(myOrdersListUrl, mapdata, headers);
      console.log("MyOrders", res);
      dispatch({
        type: MY_ORDERS_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const order_edit_details = (userId, OrderID) => async (dispatch) => {
  try {
    const mapdata = {
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      OrderID: OrderID,
    };
    const params = {
      userId: mapdata.userId === "" ? null : mapdata.userId,
      OrderID: mapdata.OrderID === "" ? null : mapdata.OrderID,
    };
    console.log("Orders Details mapdata...", mapdata);
    const res = await axiosGet(editOrderUrl, params, headers);
    console.log("order details", res);
    dispatch({
      type: EDIT_ORDER_ACTION_TYPE,
      payload: res,
    });
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
};
export const order_approval_action =
  (
    OrderID,
    Is_Approved,
    RejectedReasonID,
    RejectReason,
    RejectionNote,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    AsAmount,
    isProformaInsert
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          OrderID: OrderID ? OrderID.toString().trim() : "",
          Is_Approved: Is_Approved ? 1 : 0,
          RejectedReasonID: RejectedReasonID
            ? RejectedReasonID.toString().trim()
            : "",
          RejectReason: RejectReason ? RejectReason.toString().trim() : "",
          RejectionNote: RejectionNote ? RejectionNote.toString().trim() : "",
          OrderNo: OrderNo,
          username: CompanyName,
          email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
          AsAmount: AsAmount,
          isProformaInsert: isProformaInsert,
        };
        console.log("cancel reason mapdate", mapdata);
        const res = await axiosPost(orderApproveUrl, mapdata, headers);
        dispatch({
          type: ORDER_APPROVAL_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const order_delete_action =
  (OrderID, OrderNo, CompanyName, PrimaryEmailID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        OrderID: OrderID ? OrderID.toString().trim() : "",
        OrderNo: OrderNo ? OrderNo.toString().trim() : "",
        username: CompanyName,
        email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
      };
      console.log("delete mapdata", mapdata);
      const res = await axiosGet(deleteMyOrderUrl, mapdata, headers);
      dispatch({
        type: DELETE_MY_ORDER_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const order_cancel_reason_action =
  (
    userId,
    OrderID,
    CancellationReasonID,
    cancelNote,
    AdminRemark,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    RoleID,
    OrderAmount,
    ConvenienceFee,
    RefundAmount
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          OrderID: OrderID ? OrderID.toString().trim() : "",
          ReasonID: CancellationReasonID
            ? CancellationReasonID.toString().trim()
            : "",
          cancelNote: cancelNote ? cancelNote.toString().trim() : "",
          AdminRemark: AdminRemark ? AdminRemark.toString().trim() : "",
          OrderNo: OrderNo,
          username: CompanyName,
          email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
          RoleID: RoleID,
          OrderAmount: OrderAmount ? OrderAmount : null,
          ConvenienceFee: ConvenienceFee ? ConvenienceFee : null,
          RefundAmount: RefundAmount ? RefundAmount : null,
        };
        console.log("cancel reason mapdate", mapdata);
        const res = await axiosPost(cancelOrderReasonUrl, mapdata, headers);
        dispatch({
          type: ORDER_CANCEL_REASON_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const blocked_till_action =
  (
    userId,
    OrderID,
    BlockedDate,
    Is_release,
    ItmeCenter,
    BookingDate,
    PrimaryEmailID
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          OrderID: OrderID ? OrderID.toString().trim() : "",
          date: BlockedDate ? moment(BlockedDate).format("YYYY-MM-DD") : null,
          Is_release: Is_release,
          ItmeCenter: ItmeCenter,
          BookingDate: BookingDate,
          username: JSON.parse(sessionStorage.getItem("UserLoginData")).UserName,
          email: PrimaryEmailID,
        };
        console.log("blocked till mapdate", mapdata);
        const res = await axiosPost(blockedTillUrl, mapdata, headers);
        dispatch({
          type: BLOCKED_TILL_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const get_follow_up_action =
  (userId, OrderID, FromDate, ToDate, StatusID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        OrderID: OrderID,
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        OrderID: mapdata.OrderID === "" ? null : mapdata.OrderID,
      };
      console.log("Followup get mapdata...", mapdata);
      const res = await axiosGet(getFollowUpUrl, params, headers);
      console.log("MyOrders", res);
      dispatch({
        type: GET_FOLLOWUP_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const follow_up_add_action =
  (userId, OrderID, Note) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        OrderID: OrderID ? OrderID.toString().trim() : "",
        Note: Note ? Note.toString().trim() : "",
      };
      console.log("Follow up mapdate", mapdata);
      const res = await axiosPost(followUpurl, mapdata, headers);
      dispatch({
        type: FOLLOW_UP_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const insert_proforma_invoice_action =
  (OrderID, Is_Receipt, Is_25percent) => async (dispatch) => {
    try {
      const mapdata = {
        OrderID: OrderID,
        Is_Receipt: (Is_Receipt = 0),
        Is_25percent: (Is_25percent = 0),
      };
      console.log("Proforma add mapdata...", mapdata);
      const res = await axiosPost(insertProformaInvoiceUrl, mapdata, headers);
      dispatch({
        type: INSERT_PROFORMA_INVOICE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const download_booking_form_action =
  (userId, OrderID, OrderNo) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@OrderID",
        ParameterValue: OrderID,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);

      const mapData = {
        user_id: userId,
        report_name: bookingFormRPT,
        report_file_name: `Booking_Form_${OrderNo}`,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);

      dispatch({
        type: DOWNLOAD_BOOKING_FORM,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const download_performa_invoice_action =
  (userId, id, ProformaInvoice_No, type) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@ProformaInvoiceID",
        ParameterValue: id,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);

      const mapData = {
        user_id: userId,
        report_name: type == 1 ? performaInvoice : performaInvoiceExit,
        report_file_name: `PROFORMA_INVOICE_${ProformaInvoice_No}`,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);

      dispatch({
        type: DOWNLOAD_PERFORMA_INVOICE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const download_tax_invoice_action =
  (userId, id, ProformaInvoice_No) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@ProformaInvoiceID",
        ParameterValue: id,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);

      const mapData = {
        user_id: userId,
        report_name: taxInvoice,
        report_file_name: `TAX_INVOICE_${ProformaInvoice_No}`,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);

      dispatch({
        type: DOWNLOAD_TAX_INVOICE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const generate_nodue_action =
  (
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    ProformaInvoiceID,
    ProformaInvoice_No
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? ""
              : sessionStorage.getItem("userId"),
          OrderID: OrderID,
          OrderNo: OrderNo,
          username: CompanyName,
          email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
          ProformaInvoiceID: ProformaInvoiceID,
          ProformaInvoice_No: ProformaInvoice_No,
        };
        console.log("generate noDue mapdata...", mapdata);
        const res = await axiosPost(generateNoDueUrl, mapdata, headers);
        dispatch({
          type: GENERATE_NODUE_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const download_no_due_action =
  (OrderID, OrderNo) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@OrderID",
        ParameterValue: OrderID,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);

      const mapData = {
        user_id:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? null
            : sessionStorage.getItem("userId"),
        report_name: noDueCertificate,
        report_file_name: `NO_DUE_CERTIFICATE_${OrderNo}`,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);

      dispatch({
        type: DOWNLOAD_NODUE_ACTION_TYPE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const download_exitPass_action =
  (userId, OrderID, OrderNo) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@OrderID",
        ParameterValue: OrderID,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);

      const mapData = {
        user_id:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? null
            : sessionStorage.getItem("userId"),
        report_name: exitPassCertificate,
        report_file_name: `EXIT_PASS_${OrderNo}`,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);

      dispatch({
        type: DOWNLOAD_NODUE_ACTION_TYPE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const update_exit_pass_action =
  (OrderID, OrderNo, CompanyName, PrimaryEmailID, UUID) => async (dispatch) => {
    try {
      const mapData = {
        UserID:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? null
            : sessionStorage.getItem("userId"),
        OrderID: OrderID,
        OrderNo: OrderNo,
        username: CompanyName ? CompanyName.toString().trim() : "",
        email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
        UUID: UUID,
      };
      console.log("exit pass action", mapData);
      const res = await axiosPost(updateExitPassUrl, mapData, headers);
      dispatch({
        type: UPDATE_EXIT_PASS_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const event_closure_action = (OrderID) => async (dispatch) => {
  try {
    const mapData = {
      UserId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? null
          : sessionStorage.getItem("userId"),
      OrderId: OrderID,
    };
    console.log("event closure action", mapData);
    const res = await axiosPost(eventClosureUrl, mapData, headers);
    dispatch({
      type: EVENT_CLOSURE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const payment_action = (payload) => async (dispatch) => {
  try {
    console.log("data----------", payload);
    const res = await axiosPost(paymentUrl, payload, headers);

    dispatch({
      type: PAYMENT_ACTION_TYPE,
      payload: res,
    });
    console.log(res);

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const generate_unique_no_action =
  (userID, finalUniqueNo, orderIDList) => async (dispatch) => {
    try {
      const mapData = {
        UserID:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? null
            : sessionStorage.getItem("userId"),
        UniqueNo: finalUniqueNo,
        orderIDList: orderIDList,
      };
      console.log("data----------", mapData);
      const res = await axiosPost(generateUniqueNoUrl, mapData, headers);

      dispatch({
        type: GENERATE_UNIQUE_NO,
        payload: res,
      });
      console.log(res);

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const postUpdate_additional_services_action =
  (
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    orderDtlID,
    CenterID,
    // submitOrApproveAdditional,
    unlistedAddServices,
    OtherInformation,
    BookingDetailsAdditionalServices,
    ExternalServices,
    requestServiceMailList,
    inhouseTotal
  ) =>
    async (dispatch) => {
      console.log("add Update Additional Services was called");
      try {
        const payload = {
          UserID:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? null
              : sessionStorage.getItem("userId"),
          OrderID: OrderID,
          OrderNo: OrderNo,
          OrderDtlID: orderDtlID != "" ? orderDtlID : null,
          CenterID: CenterID,
          // SubmitOrApproveAdditional: submitOrApproveAdditional,
          UnlistedAddServices: unlistedAddServices ? unlistedAddServices : "",
          BookingDetailsAdditionalServices: BookingDetailsAdditionalServices,
          IncludedServices: null,
          ExternalServices: ExternalServices != "" ? ExternalServices : null,
          OtherInformation: OtherInformation
            ? OtherInformation.toString().trim()
            : null,
          CompanyName: CompanyName,
          PrimaryEmailID: PrimaryEmailID,
          requestServiceMailList: requestServiceMailList,
          inhouseTotal: inhouseTotal,
        };
        console.log("AdditionalService", payload);
        const response = await axiosPost(
          orderAdditionalServicesIEUrl,
          payload,
          headers
        );
        dispatch({
          type: ORDER_ADDITIONAL_SERVICE_IE_TYPE,
          payload: response,
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    };
export const update_additional_service_approval_action =
  (
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    orderDtlID,
    CenterID,
    submitOrApproveAdditional,
    unlistedAddServices,
    OtherInformation,
    BookingDetailsAdditionalServices,
    ExternalServices,
    AsAmount,
    isProformaInsert,
    VendorMailData
  ) =>
    async (dispatch) => {
      try {
        const mapData = {
          UserId:
            parseInt(sessionStorage.getItem("userId")) == "" ||
              parseInt(sessionStorage.getItem("userId")) == null
              ? null
              : parseInt(sessionStorage.getItem("userId")),
          OrderID: OrderID,
          OrderNo: OrderNo,
          CompanyName: CompanyName,
          PrimaryEmailID: PrimaryEmailID,
          OrderDtlID: orderDtlID != "" ? orderDtlID : null,
          CenterID: CenterID,
          SubmitOrApproveAdditional: submitOrApproveAdditional,
          UnlistedAddServices: unlistedAddServices ? unlistedAddServices : "",
          BookingDetailsAdditionalServices: BookingDetailsAdditionalServices,
          IncludedServices: null,
          ExternalServices: ExternalServices != "" ? ExternalServices : null,
          OtherInformation: OtherInformation
            ? OtherInformation.toString().trim()
            : null,
          AsAmount: AsAmount,
          isProformaInsert: isProformaInsert,
          VendorMailData: VendorMailData.length == 0 ? null : VendorMailData,
        };
        console.log("update_additional_service_approval_action action", mapData);
        const res = await axiosPost(
          orderAdditionalServicesApprovalUrl,
          mapData,
          headers
        );
        dispatch({
          type: ORDER_ADDITIONAL_SERVICE_APPROVAL_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const update_additional_hour =
  (OrderID, AdditionalHours, AdditionalHourCharges, OvernightCharges) =>
    async (dispatch) => {
      try {
        console.log(
          OrderID,
          AdditionalHours,
          AdditionalHourCharges,
          OvernightCharges,
          "from action"
        );
        const mapData = {
          UserId:
            parseInt(sessionStorage.getItem("userId")) == "" ||
              parseInt(sessionStorage.getItem("userId")) == null
              ? null
              : parseInt(sessionStorage.getItem("userId")),
          OrderID: OrderID,
          AdditionalHours: AdditionalHours ? parseInt(AdditionalHours) : null,
          AdditionalHourCharges: AdditionalHourCharges
            ? AdditionalHourCharges
            : null,
          OvernightCharges: OvernightCharges ? OvernightCharges : null,
        };
        console.log("update_additional_hour action", mapData);
        const res = await axiosPost(
          orderUpdateAdditionalHourUrl,
          mapData,
          headers
        );
        dispatch({
          type: ORDER_UPDATE_ADDITIONAL_HOUR,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const update_additional_discount =
  (OrderID, AdditionalDiscount, AdditionalDiscountNote) => async (dispatch) => {
    try {
      console.log(
        OrderID,
        AdditionalDiscount,
        AdditionalDiscountNote,
        "from action"
      );
      const mapData = {
        UserId:
          parseInt(sessionStorage.getItem("userId")) == "" ||
            parseInt(sessionStorage.getItem("userId")) == null
            ? null
            : parseInt(sessionStorage.getItem("userId")),
        OrderID: OrderID,
        AdditionalDiscount: AdditionalDiscount
          ? parseInt(AdditionalDiscount)
          : null,
        AdditionalDiscountNote: AdditionalDiscountNote
          ? AdditionalDiscountNote
          : null,
      };
      console.log("update_additional_Discount action", mapData);
      const res = await axiosPost(
        orderUpdateAdditionalDiscountUrl,
        mapData,
        headers
      );
      dispatch({
        type: ORDER_UPDATE_ADDITIONAL_DISCOUNT,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const update_security_deposit =
  (OrderID, SecurityDeposit, SecurityDepositRemark) => async (dispatch) => {
    try {
      console.log(
        OrderID,
        SecurityDeposit,
        SecurityDepositRemark,
        "from action"
      );
      const mapData = {
        UserId:
          parseInt(sessionStorage.getItem("userId")) == "" ||
            parseInt(sessionStorage.getItem("userId")) == null
            ? null
            : parseInt(sessionStorage.getItem("userId")),
        OrderID: OrderID,
        SecurityDeposit: SecurityDeposit ? parseInt(SecurityDeposit) : null,
        SecurityDepositRemark: SecurityDepositRemark
          ? SecurityDepositRemark
          : null,
      };
      console.log("update_security_deposit action", mapData);
      const res = await axiosPost(
        orderUpdateSecurityDepositUrl,
        mapData,
        headers
      );
      dispatch({
        type: ORDER_UPDATE_SECURITY_DEPOSIT,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const update_rental_discount =
  (OrderID, RentalDiscount, DiscountAmountNote) => async (dispatch) => {
    try {
      console.log(OrderID, RentalDiscount, DiscountAmountNote, "from action");
      const mapData = {
        UserId:
          parseInt(sessionStorage.getItem("userId")) == "" ||
            parseInt(sessionStorage.getItem("userId")) == null
            ? null
            : parseInt(sessionStorage.getItem("userId")),
        OrderID: OrderID,
        RentalDiscount: RentalDiscount ? parseInt(RentalDiscount) : null,
        DiscountAmountNote: DiscountAmountNote ? DiscountAmountNote : "",
      };
      console.log("update_Rental_Discount action", mapData);
      const res = await axiosPost(
        orderUpdateRentalDiscountUrl,
        mapData,
        headers
      );
      dispatch({
        type: ORDER_UPDATE_RENTAL_DISCOUNT,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const update_event_service =
  (OrderID, EventServiceAmount, EventServiceNote) => async (dispatch) => {
    try {
      console.log(OrderID, EventServiceAmount, EventServiceNote, "from action");
      const mapData = {
        UserId:
          parseInt(sessionStorage.getItem("userId")) == "" ||
            parseInt(sessionStorage.getItem("userId")) == null
            ? null
            : parseInt(sessionStorage.getItem("userId")),
        OrderID: OrderID,
        EventServiceAmount: EventServiceAmount
          ? parseInt(EventServiceAmount)
          : null,
        EventServiceNote: EventServiceNote ? EventServiceNote : "",
      };
      console.log("update_Rental_Discount action", mapData);
      const res = await axiosPost(orderUpdateEventServiceUrl, mapData, headers);
      dispatch({
        type: ORDER_UPDATE_EVENT_SERVICE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const send_approval_pi_mail_action =
  (
    PiType,
    OrderID,
    OrderNo,
    companyName,
    primaryEmailID,
    ProformaInvoiceID,
    ProformaInvoice_No,
    VendorMailData
  ) =>
    async (dispatch) => {
      try {
        const mapData = {
          UserId:
            sessionStorage.getItem("userId") == "" ||
              sessionStorage.getItem("userId") == null
              ? null
              : sessionStorage.getItem("userId"),
          PiType: PiType,
          OrderID: OrderID,
          OrderNo: OrderNo,
          companyName: companyName,
          primaryEmailID: primaryEmailID,
          ProformaInvoiceID: ProformaInvoiceID,
          ProformaInvoice_No: ProformaInvoice_No,
          VendorMailData: VendorMailData != [] ? VendorMailData : [],
        };
        console.log("event closure action", mapData);
        const res = await axiosPost(sendApprovalPiMailUrl, mapData, headers);
        dispatch({
          type: SEND_APPROVAL_PI_MAIL,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
